var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowRegular = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 29C15.4477 29 15 28.5523 15 28V6.41422L6.70711 14.7071C6.31658 15.0976 5.68342 15.0976 5.29289 14.7071C4.90237 14.3166 4.90237 13.6834 5.29289 13.2929L15.2929 3.29289C15.6834 2.90237 16.3166 2.90237 16.7071 3.29289L26.7071 13.2929C27.0976 13.6834 27.0976 14.3166 26.7071 14.7071C26.3166 15.0976 25.6834 15.0976 25.2929 14.7071L17 6.41421V28C17 28.5523 16.5523 29 16 29Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowRegular, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-regular.dc71e8a5.svg";
export { ForwardRef as ReactComponent };